"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumBy = exports.subtract = exports.multiply = exports.fromCents = exports.from = exports.dollars = exports.cents = void 0;
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var cents = function (value) { return value.centAmount; };
exports.cents = cents;
var dollars = function (value) {
    if (!value)
        return NaN;
    return (0, exports.cents)(value) / 100;
};
exports.dollars = dollars;
function from(value) {
    return value === undefined
        ? undefined
        : __assign({ type: 'centPrecision', fractionDigits: 2 }, (typeof value === 'number'
            ? { centAmount: Math.round(value * 100), currencyCode: 'USD' }
            : value));
}
exports.from = from;
var fromCents = function (centAmount) {
    return from({ centAmount: centAmount, currencyCode: 'USD' });
};
exports.fromCents = fromCents;
var multiply = function (value, multiplier) { return (__assign(__assign({}, value), { centAmount: Math.round((0, exports.cents)(value) * multiplier) })); };
exports.multiply = multiply;
var subtract = function (a, b) {
    return (0, exports.fromCents)(a.centAmount - b.centAmount);
};
exports.subtract = subtract;
var sumBy = function (collection, iteratee) { return (0, exports.fromCents)((0, sumBy_1.default)(collection, function (t) { var _a, _b; return (_b = (_a = iteratee(t)) === null || _a === void 0 ? void 0 : _a.centAmount) !== null && _b !== void 0 ? _b : 0; })); };
exports.sumBy = sumBy;
exports.default = {
    cents: exports.cents,
    dollars: exports.dollars,
    from: from,
    fromCents: exports.fromCents,
    multiply: exports.multiply,
    subtract: exports.subtract,
    sumBy: exports.sumBy,
};
//# sourceMappingURL=money.js.map